module.exports = __webpack_public_path__ + "static/media/page-16.56336c5b.png";